module.exports = __webpack_public_path__ + "static/img/pitch.5bfc1fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/pitch.png
// module id = YjLV
// module chunks = 2